import type { Metadata } from "next";
import { StaticPage } from "@/components/static-page";

export const metadata: Metadata = {
  title: "Chính sách biên tập",
  description:
    "Quy chuẩn biên tập của Finzone Network: nguồn dữ liệu, quy trình kiểm duyệt, đính chính, xung đột lợi ích.",
  alternates: { canonical: "/chinh-sach-bien-tap" },
};

export default function Page() {
  return (
    <StaticPage
      title="Chính sách biên tập"
      eyebrow="Quy chuẩn"
      description="Cách Finzone xác minh, biên tập và đính chính nội dung — để bạn biết tin tức bạn đang đọc đến từ đâu."
    >
      <h2>Nguồn dữ liệu</h2>
      <p>
        Chúng tôi ưu tiên dữ liệu từ nguồn chính thức: ngân hàng nhà nước, sở giao dịch chứng khoán,
        công ty đại chúng (BCTC, công bố thông tin), cơ quan quản lý (SBV, SSC, SEC, Fed),
        sàn crypto lớn (Binance, Coinbase, OKX), nhà cung cấp dữ liệu thị trường (TradingView,
        CoinGecko, World Gold Council). Khi tham khảo nguồn thứ cấp, chúng tôi luôn ghi rõ nguồn.
      </p>

      <h2>Quy trình biên tập</h2>
      <ol>
        <li>Phóng viên/cộng tác viên gửi bài kèm dữ liệu chứng minh.</li>
        <li>Biên tập viên kiểm tra số liệu, ngữ cảnh, độ chính xác của tiêu đề.</li>
        <li>Bài có khuyến nghị hoặc nhận định mạnh phải được trưởng ban duyệt lần hai.</li>
        <li>Sau khi xuất bản, mọi cập nhật quan trọng được ghi rõ thời điểm cuối bài.</li>
      </ol>

      <h2>Đính chính</h2>
      <p>
        Khi phát hiện sai số liệu, sai tên, sai ngữ cảnh hoặc sai luận điểm, chúng tôi sửa và
        ghi <em>“Đính chính”</em> kèm thời gian cuối bài. Nếu sai sót lớn, bài sẽ có một paragraph
        nói rõ nội dung nào đã sai và nội dung đúng là gì.
      </p>

      <h2>Xung đột lợi ích và quảng cáo</h2>
      <p>
        Finzone <strong>có nhận quảng cáo</strong> để duy trì hoạt động: banner, native content, bài
        tài trợ. Mọi nội dung quảng cáo đều được gắn nhãn rõ ràng <em>“Tài trợ”</em>, <em>“Hợp tác”</em>
        hoặc <em>“Quảng cáo”</em> ngay tiêu đề và đầu bài. Quảng cáo không ảnh hưởng đến nội dung
        biên tập độc lập của chúng tôi.
      </p>
      <p>
        Tác giả không được viết khuyến nghị mua/bán về một tài sản mà bản thân đang giữ vị thế lớn
        và sắp đóng. Khi bài có affiliate link (vd: link đăng ký sàn giao dịch), chúng tôi gắn
        nhãn <em>“Link liên kết”</em> kèm thông báo Finzone có thể nhận hoa hồng.
      </p>

      <h2>Bình luận và phản hồi</h2>
      <p>
        Phản hồi từ độc giả về sai sót được tiếp nhận qua <a href="/lien-he">trang Liên hệ</a>.
        Chúng tôi cam kết phản hồi trong 48 giờ làm việc cho yêu cầu đính chính có dẫn chứng.
      </p>
    </StaticPage>
  );
}
